import { Navigate, Route, Routes } from "react-router-dom";

import Layout from "./components/Layout";
import { Spinner } from "./components/ui";
import { useCurrentUser } from "./hooks/useAuth";
import Account from "./routes/Account";
import ApplicationDetail from "./routes/ApplicationDetail";
import Board from "./routes/Board";
import Invites from "./routes/Invites";
import Applications from "./routes/Applications";
import Login from "./routes/Login";
import NewApplication from "./routes/NewApplication";
import ProfilePage from "./routes/ProfilePage";
import Templates from "./routes/Templates";

export default function App() {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Layout user={user}>
      <Routes>
        <Route path="/" element={<Applications />} />
        <Route path="/new" element={<NewApplication />} />
        <Route path="/applications/:id" element={<ApplicationDetail />} />
        <Route path="/board" element={<Board />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/invites" element={<Invites />} />
        <Route path="/account" element={<Account />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
